import { useEffect } from 'react'

import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

import styled from '@emotion/styled'
import { fetchSavedRows } from 'Pages/Campaign/recoil/actions/beeSavedRowsActions'
import {
  deleteBeeSavedRowCallback,
  editBeeSavedRowCallback
} from 'Pages/Campaign/recoil/callbacks/beeSavedRowsCallback'
import {
  checkBeePluginCallback,
  initBeePluginCallback,
  onBeeSaveCallback,
  updateAutosaveCallback
} from 'Pages/Campaign/recoil/callbacks/callbackEditBee'
import { beePluginState, editorState } from 'Pages/Campaign/recoil/state/bee'
import { pageState } from 'Pages/Campaign/recoil/state/page'

const StyledBeeContainer = styled.div`
  left: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 60px;
  overflow: hidden;
`
const BeePluginEditor = () => {
  const initBeePlugin = useRecoilCallback(initBeePluginCallback, [])
  const handleBeeSave = useRecoilCallback(onBeeSaveCallback, [])
  const handleAutosave = useRecoilCallback(updateAutosaveCallback, [])
  const checkBeePlugin = useRecoilCallback(checkBeePluginCallback, [])
  const resetPlugin = useResetRecoilState(beePluginState)
  const setEditor = useSetRecoilState(editorState)
  const { initBeePlugin: start } = useRecoilValue(pageState)
  const editBeeSavedRow = useRecoilCallback(editBeeSavedRowCallback, [])
  const deleteBeeSavedRow = useRecoilCallback(deleteBeeSavedRowCallback, [])

  const handleChange = () => {
    setEditor((prev) => ({
      ...prev,
      dirty: true,
      saved: false
    }))
  }

  useEffect(() => {
    // check
    // initLoadPlugin({
    //   id: Number(id || 0),
    //   mode,
    //   template,
    //   idTemplate: Number(idTemplate || 0),
    //   isNewNotificationMessage,
    //   enableNotification
    // })
    // if (beeCommentingEnabled) {
    //   setListUsers()
    // }
    checkBeePlugin()
    return () => {
      // resetPlugin()
      // resetEditor()
    }
  }, [])

  useEffect(() => {
    if (start) {
      const init = async () =>
        await initBeePlugin({
          settings: {
            onSave: handleBeeSave,
            onAutosave: handleAutosave,
            onChange: handleChange,
            contentDialog: {
              onDeleteRow: {
                handler: async (resolve, reject, args) => {
                  //  modale di conferma già gestita dal Bee

                  deleteBeeSavedRow(resolve, reject, args.row)
                }
              },

              onEditRow: {
                handler: async (resolve, reject, args) => {
                  //  args.row.metadata

                  //  args.row
                  //  args.row.metadata

                  //  edit metadati
                  //  save di args merge nuovi metadati
                  //  resolve con
                  //  - true per aggiornare rows (es: confirm delle modifiche)
                  //  - false per non aggiornare rows (es: cancel delle modifiche)

                  editBeeSavedRow(
                    resolve,
                    reject,
                    args.row,
                    args.row.metadata,
                    false
                  )
                }
              },

              saveRow: {
                handler: function (resolve, reject, args) {
                  //  raccogli metadati
                  //  save di args merge metadati
                  //  resolve con metadati

                  editBeeSavedRow(resolve, reject, args, {}, true)
                }
              }
            },
            hooks: {
              getRows: {
                handler: async (resolve, reject, args) => {
                  try {
                    const rows = await fetchSavedRows(args)

                    resolve(rows)
                  } catch (e) {
                    //  log error
                    reject(e)
                  }
                }
              }
            }
          }
        })
      init()
    }
    return () => {
      resetPlugin()
    }
  }, [start])

  return <StyledBeeContainer id='bee-plugin-container' />
}

export default BeePluginEditor
